export default __webpack_public_path__ + "static/media/paw.ff609ee0.svg";